import { Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionExpireRows extends Layout {
    labelExpireDate: Label;
    panelExpiringRows: Panel;
    textboxExpireDate: Textbox;
}
